/*
=========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/    o o o   

=========================================================
*/

export const CLEAR_STATE = "CLEAR_STATE";
export const SET_TOKEN = "SET_TOKEN";
export const SET_LANG = "SET_LANG";
export const SET_USER = "SET_USER";
export const SET_PERM = "SET_PERM";
export const SET_MENU = "SET_MENU";
export const SET_NOTIFY = "SET_NOTIFY";
export const SET_BADGE = "SET_BADGE";

export function clearState() {
  return {
    type: CLEAR_STATE,
    payload: {},
  };
}

export function setToken(id) {
  return {
    type: SET_TOKEN,
    payload: id,
  };
}

export function setLang(id) {
  return {
    type: SET_LANG,
    payload: id,
  };
}

export function setUser(data) {
  return {
    type: SET_USER,
    payload: data,
  };
}

export function setPerm(data) {
  return {
    type: SET_PERM,
    payload: data,
  };
}

export function setMenu(data) {
  return {
    type: SET_MENU,
    payload: data,
  };
}

export function setNotify(data) {
  return {
    type: SET_NOTIFY,
    payload: data,
  };
}

export function setBadge(data) {
  return {
    type: SET_BADGE,
    payload: data,
  };
}
